<template>
	<v-card-text>
		<v-item-group class="ml-5 mr-5 pb-2 mb-2">
			<v-main>
				<v-row>
					<v-col v-for="n in required_forms" :key="n.context" cols="6" md="3">
						<v-item v-slot="{}">
							<profile-step-button
								:image_o="n.image_o"
								:image_g="n.image_g"
								:image_w="n.image_w"
								:image_width="n.image_width"
								:image_height="n.image_height"
								:form="n.form"
								:text="n.text"
								:context="n.context"
								:button-colour="buttonColours[n.context]"
							></profile-step-button>
						</v-item>
					</v-col>
				</v-row>
			</v-main>
		</v-item-group>

		<v-main align="center" justify="center" class="pa-5">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-wrap"><h2>Increase your profile strength for more visibility</h2></v-list-item-title>
					<v-list-item-subtitle class="text-wrap"></v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-main>

		<!-- boosters -->
		<v-item-group class="ml-5 mr-5 pt-2 mt-2">
			<v-main>
				<v-row>
					<v-col v-for="n in booster_forms" :key="n.context" cols="6" md="3">
						<v-item v-slot="{}">
							<profile-step-button
								:image_o="n.image_o"
								:image_g="n.image_g"
								:image_w="n.image_w"
								:image_width="n.image_width"
								:image_height="n.image_height"
								:form="n.form"
								:text="n.text"
								:context="n.context"
								:button-colour="buttonColours[n.context]"
							></profile-step-button>
						</v-item>
					</v-col>
				</v-row>
			</v-main>
		</v-item-group>
	</v-card-text>
</template>

<script>
import { bus } from '@/main';

import ProfileStepButton from '@/components/locum/profile/ProfileStepButton.vue';

export default {
	components: {
		ProfileStepButton,
	},
	props: {
		required_forms: Array,
		booster_forms: Array,
		buttonColours: Object,
	},
	data: () => ({
		name: 'CompleteProfileStepsForm',
	}),

	created() {},

	mounted() {
		bus.$on('intent:submit-forms', () => {
			bus.$off('intent:submit-forms');
			bus.$emit('intent:next-step', 'complete-profile-steps');
		});
	},

	beforeDestroy() {
		bus.$off('intent:submit-forms');
	},
};
</script>
